export interface Author {
  id: string;
  description: string;
  name: string;
  imageUrl: string;
}

export const ochikobore: Author = {
  id: "uc6o6u5co",
  description:
    "何を血迷ったか、社会人留学をすることになった20代女性。できるなら何もせず生きたいと切実に願っている。英語が上手くなりたい。",
  name: "落ちこぼれ蒙古斑",
  imageUrl: "/author/uc6o6u5co.png",
};

export const takegushi: Author = {
  id: "k2ek1e",
  description:
    "どこにでもいるような20代男性。室外機とか鉄道とか地味に生活を支えているものが好み。サッカーをよく観る。料理ができるようになりたい。",
  name: "みっともナトゥーリヒィ7世",
  imageUrl: "/author/k2ek1e.png",
};

export const authors: Author[] = [ochikobore, takegushi];
